import ButtonIcon from 'components/ButtonIcon';
import HiddenAnchor from 'components/HiddenAnchor';
import Download from 'components/icons/download';
import { useCallback, useRef, useState } from 'react';
import { ButtonIconProps } from 'react-rainbow-components/components/ButtonIcon';

interface Props extends Omit<ButtonIconProps, 'icon' | 'onClick'> {
    url: string;
    name: string;
    originalName: string;
}

const DownloadButton = ({
    url,
    name,
    originalName,
    tooltip = 'Download File',
    disabled = false,
    ...buttonProps
}: Props) => {
    const hiddenLinkRef = useRef<HTMLAnchorElement>(null);
    const [isDownloading, setIsDownloading] = useState(false);

    const download = useCallback(async () => {
        if (!hiddenLinkRef.current) return;

        setIsDownloading(true);
        const originalExt = originalName.split('.').pop();
        try {
            const res = await fetch(url);
            const blob = await res.blob();
            const downloadUrl = URL.createObjectURL(blob);
            hiddenLinkRef.current.href = downloadUrl;
            hiddenLinkRef.current.download = `${name}.${originalExt}`;
            hiddenLinkRef.current.click();
        } catch (error) {
            console.error('Error downloading file', error);
        }
        setIsDownloading(false);
    }, [name, originalName, url]);

    return (
        <>
            <HiddenAnchor ref={hiddenLinkRef} />
            <ButtonIcon
                borderRadius="semi-square"
                size="small"
                tooltip={tooltip}
                {...buttonProps}
                icon={<Download />}
                onClick={download}
                disabled={isDownloading || disabled}
            />
        </>
    );
};

export default DownloadButton;
